import AbstractAPI from '@/services/api/AbstractAPI';

export default class InvoicesAPI extends AbstractAPI {

  constructor(client, options) {
    super(client, options, '/invoice');
  }

  async list(options) {
    return this.makeRequest('/inventory', 'get', {params: options});
  }

  async listUnpaid(options) {
    return this.makeRequest('/all-unpaid', 'get', {params: options});
  }
}
